module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-wrapper",
    class: {
      playable: _vm.isPlayable, fullscreen: _vm.isFullScreen
    }
  }, [(_vm.isVideo) ? _c('video', {
    attrs: {
      "src": _vm.getStaticPath('img/temp/test_video.png')
    }
  }) : _c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.issue.files.figures[_vm.$parent.selectedId].optimized_urls.hero
    }
  }), _vm._v(" "), (_vm.isVideo) ? _c('div', {
    staticClass: "play-button",
    style: ({
      backgroundImage: 'url(' + _vm.getStaticPath('img/play-circle.png') + ')'
    }),
    on: {
      "click": function($event) {
        _vm.playVideo($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.share) ? _c('div', {
    staticClass: "share-button",
    style: ({
      backgroundImage: 'url(' + _vm.getStaticPath('img/share-circle.png') + ')'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.header && !_vm.collectionsHeader) ? _c('div', {
    staticClass: "issue-header"
  }, [_c('div', {
    staticClass: "articleType"
  }, [_vm._v("Article Type: "), _c('span', [_vm._v(_vm._s(_vm.issue.article_type.name))])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trimTextToLength(_vm.issue.title, 100)))])]) : _vm._e(), _vm._v(" "), (_vm.collectionsHeader) ? _c('div', {
    staticClass: "issue-header"
  }, [_c('div', {
    staticClass: "articleType",
    domProps: {
      "innerHTML": _vm._s(_vm.issue.caption)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trimTextToLength(_vm.issue.title, 100)))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f0ef6f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MediaPlayerComponent.vue
// module id = 1456
// module chunks = 1